import type { MouseEvent, ReactNode } from "react";
import styles from "./Button.module.css";

type ButtonProps = {
  children: ReactNode;
  /** 尺寸：default 40px / sm 32px */
  size?: "default" | "sm";
  /** 描边风格（Outline） */
  ghost?: boolean;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
};

const Button = ({
  children,
  size = "default",
  ghost = false,
  disabled = false,
  type = "button",
  onClick,
  className,
}: ButtonProps) => {
  const classes = [
    styles.btn,
    ghost ? styles.ghost : styles.primary,
    size === "sm" ? styles.sm : "",
    disabled ? styles.disabled : "",
    className || "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;
